import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';

import { AccountDetailsComponent } from '../account-details/account-details.component';
import { CurrentBillComponent } from '../current-bill/current-bill.component';
import { PowerUsageComponent } from '../power-usage/power-usage.component';
import { BillingHistoryComponent } from '../billing-history/billing-history.component';

import { LoginService } from '../services/login.service';
import { AccountDetailsService } from '../services/account-details.service';

import { AccountDeviceModel } from '../models/AccountDevicesModel';
import { CurrentAccount } from '../models/AccountModel';
import { UserInfoModel } from '../models/UserInfoModel';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.css']
})
export class PageComponent implements OnInit, AfterViewInit {

  accountsWithDevices: AccountDeviceModel;
  currentAccount: CurrentAccount;
  customerInfo: UserInfoModel;

  constructor(
    private loginService: LoginService,
    private accountDetailsService: AccountDetailsService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.loginService.getUserIsLoggedIn()
      .subscribe(isLoggedIn => {
        if (!isLoggedIn) {
          this.router.navigate(['/Login']);
        }
      });
  }

  ngAfterViewInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/page/page.component.ts